import React from 'react';
import { FaFacebook, FaXTwitter, FaInstagram, FaYoutube } from 'react-icons/fa6';
import resoluteLogo from '../FixtureResult/Image/resolute.png';

const ContactForm = () => {

  const socialLinks = [
    { href: 'https://www.facebook.com/profile.php?id=61566170158398', icon: <FaFacebook />, label: 'Facebook' },
    { href: 'https://x.com/HToofans', icon: <FaXTwitter />, label: 'Twitter' },
    { href: 'https://www.instagram.com/hyderabadtoofans/', icon: <FaInstagram />, label: 'Instagram' },
    { href: 'https://www.youtube.com/@HyderabadToofans', icon: <FaYoutube />, label: 'YouTube' },
  ];

  return (
    <section className="py-8 bg-gray-100">
      <div className="container mx-auto px-8">
        <div className="flex flex-col md:flex-row justify-between gap-8">
          <div className="md:w-1/3">
            <div className="mb-4">
              <a
                href="https://resolutecorp.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block"
              >
                <div className="bg-white shadow-md rounded-xl p-3 inline-flex items-center justify-center hover:shadow-lg transition">
                  <img
                    src={resoluteLogo}
                    alt="Resolute Sports"
                    className="h-16 object-contain"
                  />
                </div>
              </a>
              <p className="text-sm font-bold text-gray-600 mt-2">
                Resolute Sports Private Limited
              </p>
            </div>

            {/* Address */}
            <p className="text-sm mt-2">
              10th Floor, Kataria Arcade, Off SG Highway, Post: Makarba,
              Ahmedabad - 380051, Gujarat, India
            </p>

            {/* Hashtags */}
            <p className="text-sm mt-6 leading-relaxed">
              <span className="font-semibold">
                #DilSeToofan | #HyderabadToofans
              </span>
            </p>

            {/* Social Icons */}
            <div className="flex space-x-4 mt-2 text-lg">
              {socialLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#3b0067] transition"
                  aria-label={link.label}
                >
                  {link.icon}
                </a>
              ))}
            </div>

            {/* Contact Info */}
            <div className="my-2 mt-6">
              <p className="grid">
                <span className="text-xl text-[#3b0067] font-semibold">
                  Contact:
                </span>
                contact@resolutesports.in | +91 79 4992 0484
              </p>
            </div>
          </div>

          {/* Contact Form */}
          <div className="md:w-2/3 bg-white p-8 rounded-lg shadow">
            <h3 className="text-xl font-semibold mb-4">Contact Us</h3>

            <form
              className="space-y-4"
              action="https://submit-form.com/OIzHMc7kj"
            >
              {/* Name */}
              <input
                type="text"
                name="name"
                className="w-full p-3 bg-gray-300 rounded-md placeholder-gray-600 focus:ring-[#3b0067] focus:border-[#3b0067]"
                placeholder="Your Name"
              />

              {/* Mobile + Email */}
              <div className="flex flex-col md:flex-row gap-4">
                <input
                  type="tel"
                  name="mobile"
                  className="w-full p-3 bg-gray-300 rounded-md placeholder-gray-600 focus:ring-[#3b0067]"
                  placeholder="Your Mobile Number"
                />

                <input
                  type="email"
                  name="email"
                  className="w-full p-3 bg-gray-300 rounded-md placeholder-gray-600 focus:ring-[#3b0067]"
                  placeholder="Your Email Address"
                />
              </div>

              {/* Message */}
              <textarea
                name="message"
                rows="4"
                className="w-full p-3 bg-gray-300 rounded-md placeholder-gray-600 focus:ring-[#3b0067]"
                placeholder="Write your message here..."
              />

              {/* Button */}
              <button
                type="submit"
                className="px-10 py-2 bg-[#ffbd00] text-black font-semibold rounded-md shadow hover:bg-[#3b0067] hover:text-white transition"
              >
                Submit
              </button>
            </form>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactForm;